import { render, staticRenderFns } from "./OperatorOrders.vue?vue&type=template&id=4716a9d4&"
import script from "./OperatorOrders.vue?vue&type=script&lang=js&"
export * from "./OperatorOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OperatorOrders.vue"
export default component.exports